import { useState } from 'react';
import { useMount } from 'ahooks';
import { fetchCondConfigs, ICondConfigQueryParams } from '@intelligence/v3/services/common';
import { createRetryWrapper } from '@intelligence/v3/utils/enhancer';

const fetchCondConfigsRetryable = createRetryWrapper(fetchCondConfigs);

export default function useCondConfigs(props: { queryParams: IRecord<ICondConfigQueryParams> }) {
  const { queryParams } = props;

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<IRecord>({});

  useMount(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await fetchCondConfigsRetryable(queryParams);
        setData(res?.data || {});
      } catch (error) {
        console.error(error);
        setData({});
      } finally {
        setLoading(false);
      }
    };

    void fetchData();
  });

  return { loading, data };
}
